import React from 'react';
import PropTypes from 'prop-types';

import { classnames } from '../../utils';
import Loader from '../Loader';

import styles from './SimpleTable.module.scss';

const SimpleTable = ({ fields, data, placeholder = '', loading = false, className = '' }) => {
	const renderTableHeader = () => {
		return (
			<tr>
				{fields.map((field) => (
					<th key={field.title}>{field.title}</th>
				))}
			</tr>
		);
	};

	const renderRows = () => {
		return data.map((row, index) => (
			<tr key={row.id || index}>
				{fields.map((field, fieldIndex) => (
					<td key={fieldIndex} style={field.style || {}}>
						{field.formatter(row)}
					</td>
				))}
			</tr>
		));
	};

	return (
		<div>
			<table className={classnames(styles.simpleTable, className)}>
				<thead>{renderTableHeader()}</thead>
				{!data.length && placeholder ? (
					<tbody>
						<tr>
							<td>{placeholder}</td>
						</tr>
					</tbody>
				) : (
					<tbody>{renderRows()}</tbody>
				)}
			</table>
			{loading && <Loader />}
		</div>
	);
};

SimpleTable.propTypes = {
	loading: PropTypes.bool,
	fields: PropTypes.array.isRequired,
	data: PropTypes.array.isRequired
};

export default SimpleTable;
